<div class="load-file-import" [attr.data-automation-id]="automationId + '-container'">
    <div class="header-bar top" [attr.data-automation-id]="automationId + '-header'">
        <button type="button" [attr.data-automation-id]="automationId + '-save-button'" class="primary-button"
            *ngIf="hasPermissions" (click)="saveChanges()" [disabled]="isDisabled()">Save</button>
        <button type="button" [attr.data-automation-id]="automationId + '-discard-changes-button'"
            *ngIf="hasPermissions" class="secondary-button" (click)="discardChanges()"
            [disabled]="isBusy || !isDirty">Discard Changes</button>
        <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
            (click)="openHelp()"><i class="fa fa-question"></i></button>
    </div>
    <form class="content" #contentForm="ngForm" [attr.data-automation-id]="automationId + '-content'"
        [resBusySpinner]="numConcurrentRequests > 0" [message]="isBusyMessage">

        <div class="load-file-fields">
            <res-generic-grid [automationId]="automationId + '-load-file-fields'"
                [rowSelection]="loadFileFieldsSelection" [pagerVisible]="false" [columnDefs]="loadFileFieldsColumns"
                [headerTemplate]="loadFileHeaderTemplate" [rowHeightCallback]="rowHeightCallback"
                [rowClassRules]="rowDisableRulesLoadFields" [onSelectionChanged]="countSelectedLoadFileFields"
                [gridContext]="gridContextLoadFile" [onCustomFilterCallback]="onCustomFilterCallback"
                [hasCustomCellTemplates]="true">
            </res-generic-grid>
            <ng-template #loadFileHeaderTemplate>
                <div class="parent-header">
                    <span class="title">Load File Fields</span>
                    <div class="left-buttons" *ngIf="hasPermissions">
                        <button type="button" [attr.data-automation-id]="automationId + '-discover-fields-button'"
                            (click)="openDiscoverFieldsModal()" class="secondary-button"><i
                                class="fa fa-magic"></i>Discover Fields ...</button>
                        <!-- <button type="button" [attr.data-automation-id]="automationId + '-add-field-button'" (click)="addFileField()"
                            class="secondary-button"><i class="fa fa-plus"></i>Add Field</button> -->
                    </div>
                    <div class="grid-row-delete" *ngIf="hasPermissions">
                        <span (click)="deleteSelectedFileFields()" [attr.data-automation-id]="'delete-file-fields'"
                            [ngClass]="[numSelectedFileFields > 0 ? 'enabled-class' : 'disabled-class']">
                            <i class="fa fa-trash sizing-icons"></i>Delete Selected</span>
                    </div>
                </div>
            </ng-template>
        </div>

        <div class="vertical-spacer"></div>

        <div class="field-mappings" [attr.data-automation-id]="automationId + '-field-mappings-container'">
            <div class="parent-header">
                <span class="title">Field Mappings</span>
                <div class="grid-row-delete" *ngIf="hasPermissions">
                    <span (click)="deleteSelectedMappings()" [attr.data-automation-id]="'delete-mappings'"
                        [ngClass]="[numSelectedMappings > 0 ? 'enabled-class' : 'disabled-class']">
                        <i class="fa fa-trash sizing-icons"></i>Delete Selected</span>
                </div>
            </div>
            <div class="list-container no-select">
                <div class="list-header">
                    <div class="checkbox-header" *ngIf="hasPermissions">
                        <res-custom-checkbox automationId="field-mappings-list-select-all" name="selectAllCheckbox"
                            [(ngModel)]="selectAllChecked" (ngModelChange)="selectionChanged($event)"
                            [isIndeterminate]="isPartiallySelected()" [labelPaddingLeft]="10" [labelPaddingRight]="7">
                        </res-custom-checkbox>
                    </div>
                    <div class="header">
                        <span>Load File Field</span>
                    </div>
                    <div class="header transformer-header">
                        <span>Transformer</span>
                    </div>
                    <div class="header dr-metadata-header">
                        <i class="fa fa-caret-up"></i>
                        <span>DR Metadata Field</span>
                    </div>
                </div>
                <div class="list-content" [ngClass]="{'disabled': !hasPermissions}">
                    <div class="list-item" *ngFor='let item of mappings; index as i'
                        (click)="selectionChanged($event, item)"
                        [ngClass]="{'locked-row': isLocked(item) && hasPermissions, 'selected': item.isSelected, 'disabled-class': !hasPermissions}"
                        [attr.data-automation-id]="'field-mappings-list-item-' + i">
                        <res-custom-checkbox [automationId]="'field-mappings-list-item-check-' + i"
                            [(ngModel)]="item.isSelected" *ngIf="hasPermissions" name="item.isSelected_{{i}}"
                            [disabled]="isLocked(item)" [labelPaddingLeft]="10" [labelPaddingRight]="7"
                            (click)="selectionChanged($event, item)">
                        </res-custom-checkbox>
                        <span *ngIf="!item.userField" [title]="item.externalName ? item.externalName : ''"
                            class="min-cell-height" [ngClass]="leftDraggedItem ? 'dndLeftDragging' : ''"
                            [attr.data-automation-id]="'field-mappings-list-item-file-field-' + i" dndDropzone
                            (dndDrop)="onFieldDrop($event, i)"
                            [dndDisableDropIf]="draggedItem != null">{{item.externalName}}</span>
                        <div *ngIf="item.userField" class="user-field min-cell-height">
                            <input type="text" [(ngModel)]="item.externalName" name="item.externalName_{{i}}"
                                [attr.data-automation-id]="'field-mappings-list-item-file-field-textinput-' + i">
                        </div>
                        <i class="fa color-grey-16 no-permissions-icon" [ngClass]="item.iconClass"
                            *ngIf="!hasPermissions"></i>
                        <li class="dropdown" dropdown *ngIf="hasPermissions">
                            <button dropdownToggle
                                [attr.data-automation-id]="'field-mappings-list-item-transformer-' + i"
                                (mouseover)="showTransformerMenu($event, i)"
                                (mouseleave)="hideTransformerMenu($event, i)">
                                <i class="fa" [ngClass]="item.iconClass + ' ' + item.iconColor"></i>
                            </button>
                            <ul *dropdownMenu class="dropdown-menu">
                                <li *ngFor='let trans of transformerList; index as idx'
                                    (click)="openTransformerModal(item, trans.type)" class="menu-item"
                                    [ngClass]="{'disabled' : isTransformerDisabled(item.fieldTransformerType, trans.type) }"
                                    [attr.data-automation-id]="'field-mappings-list-drop-down-transformer-' + idx">
                                    <label>
                                        <i class="fa menu-item-icon"
                                            [ngClass]="trans.icon + ' ' + trans.colorClass"></i>{{trans.label}}
                                    </label>
                                </li>
                            </ul>
                        </li>
                        <span class="min-cell-height dropped-metadata" [title]="item.digitalReefMetadataValue"
                            dndDropzone [ngClass]="draggedItem ? 'dndDragging' : ''"
                            [attr.data-automation-id]="'field-mappings-list-item-metadata-' + i"
                            (dndDrop)="onMetadataFieldDrop($event, i)"
                            [dndDisableDropIf]="leftDraggedItem != null">{{item.digitalReefMetadataValue}}</span>
                    </div>
                    <div class="list-item empty-drop-zone" [attr.data-automation-id]="'empty-drop-zone'" dndDropzone
                        *ngIf="hasPermissions" (dndDrop)="onFieldDrop($event)"
                        [ngClass]="draggedItem || leftDraggedItem ? 'dndDragging' : ''">
                        <span>Drop field(s) to map here ...</span>
                    </div>
                </div>
            </div>
            <div class="horizontal-spacer"></div>
            <div class="bottom-buttons">
                <res-custom-checkbox name="preserveFamily" [automationId]="automationId + '-preserve-families'"
                    [(ngModel)]="preserveFamily" name="preserveFamily" content="Preserve Families"
                    [disabled]="isBusy || !hasPermissions" (ngModelChange)="isDirty = true; preserveToggled();">
                </res-custom-checkbox>
                <res-custom-checkbox name="loadImages" [automationId]="automationId + '-process-load-file-images'"
                    [(ngModel)]="loadImages" name="loadImages" content="Process Load File Images"
                    [disabled]="isBusy || !hasPermissions" (click)="isDirty = true"></res-custom-checkbox>
            </div>
        </div>

        <div class="vertical-spacer"></div>

        <div class="metadata-fields" *ngIf="hasPermissions">
            <res-generic-grid [automationId]="automationId + '-dr-metadata-fields'" [rowSelection]="metadataSelection"
                [pagerVisible]="false" [columnDefs]="metadataColumns" [headerTemplate]="metadataHeaderTemplate"
                [requestInfo]="metadataRequestInfo" [gridContext]="gridContext"
                [responseCallback]="metadataResponseCallback" [hasCustomCellTemplates]="true">
            </res-generic-grid>
            <ng-template #metadataHeaderTemplate>
                <div class='parent-header'>
                    <span>DR Metadata Fields</span>
                </div>
            </ng-template>
        </div>
    </form>
</div>